export default __webpack_public_path__ + "static/color-analysis-result-spring-c12a4a3a180f55dd05fe903c0b2e861c.jpg";